"use strict";

exports.__esModule = true;
exports.SlotData = exports.BlendMode = void 0;
var _Utils = require("./Utils");
/******************************************************************************
 * Spine Runtimes License Agreement
 * Last updated January 1, 2020. Replaces all prior versions.
 *
 * Copyright (c) 2013-2020, Esoteric Software LLC
 *
 * Integration of the Spine Runtimes into software or otherwise creating
 * derivative works of the Spine Runtimes is permitted under the terms and
 * conditions of Section 2 of the Spine Editor License Agreement:
 * http://esotericsoftware.com/spine-editor-license
 *
 * Otherwise, it is permitted to integrate the Spine Runtimes into software
 * or otherwise create derivative works of the Spine Runtimes (collectively,
 * "Products"), provided that each user of the Products must obtain their own
 * Spine Editor license and redistribution of the Products in any form must
 * include this license and copyright notice.
 *
 * THE SPINE RUNTIMES ARE PROVIDED BY ESOTERIC SOFTWARE LLC "AS IS" AND ANY
 * EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL ESOTERIC SOFTWARE LLC BE LIABLE FOR ANY
 * DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES,
 * BUSINESS INTERRUPTION, OR LOSS OF USE, DATA, OR PROFITS) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
 * THE SPINE RUNTIMES, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *****************************************************************************/
/** Stores the setup pose for a {@link Slot}. */
var SlotData = function SlotData(index, name, boneData) {
  /** The index of the slot in {@link Skeleton#getSlots()}. */
  this.index = 0;
  /** The name of the slot, which is unique across all slots in the skeleton. */
  this.name = null;
  /** The bone this slot belongs to. */
  this.boneData = null;
  /** The color used to tint the slot's attachment. If {@link #getDarkColor()} is set, this is used as the light color for two
   * color tinting. */
  this.color = new _Utils.Color(1, 1, 1, 1);
  /** The dark color used to tint the slot's attachment for two color tinting, or null if two color tinting is not used. The dark
   * color's alpha is not used. */
  this.darkColor = null;
  /** The name of the attachment that is visible for this slot in the setup pose, or null if no attachment is visible. */
  this.attachmentName = null;
  /** The blend mode for drawing the slot's attachment. */
  this.blendMode = null;
  if (index < 0) throw new Error("index must be >= 0.");
  if (!name) throw new Error("name cannot be null.");
  if (!boneData) throw new Error("boneData cannot be null.");
  this.index = index;
  this.name = name;
  this.boneData = boneData;
};
/** Determines how images are blended with existing pixels when drawn. */
exports.SlotData = SlotData;
var BlendMode;
exports.BlendMode = BlendMode;
(function (BlendMode) {
  BlendMode[BlendMode["Normal"] = 0] = "Normal";
  BlendMode[BlendMode["Additive"] = 1] = "Additive";
  BlendMode[BlendMode["Multiply"] = 2] = "Multiply";
  BlendMode[BlendMode["Screen"] = 3] = "Screen";
})(BlendMode || (exports.BlendMode = BlendMode = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfVXRpbHMiLCJyZXF1aXJlIiwiU2xvdERhdGEiLCJpbmRleCIsIm5hbWUiLCJib25lRGF0YSIsImNvbG9yIiwiQ29sb3IiLCJkYXJrQ29sb3IiLCJhdHRhY2htZW50TmFtZSIsImJsZW5kTW9kZSIsIkVycm9yIiwiZXhwb3J0cyIsIkJsZW5kTW9kZSJdLCJzb3VyY2VzIjpbIi4uL3NyYy9TbG90RGF0YS50cyJdLCJzb3VyY2VzQ29udGVudCI6W251bGxdLCJtYXBwaW5ncyI6Ijs7OztBQThCQSxJQUFBQSxNQUFBLEdBQUFDLE9BQUE7QUE5QkE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFnQ0E7QUFBQSxJQUNhQyxRQUFRLEdBd0JwQixTQUFBQSxTQUFhQyxLQUFhLEVBQUVDLElBQVksRUFBRUMsUUFBa0I7RUF2QjVEO0VBQ0EsS0FBQUYsS0FBSyxHQUFXLENBQUM7RUFFakI7RUFDQSxLQUFBQyxJQUFJLEdBQVcsSUFBSTtFQUVuQjtFQUNBLEtBQUFDLFFBQVEsR0FBYSxJQUFJO0VBRXpCOztFQUVBLEtBQUFDLEtBQUssR0FBRyxJQUFJQyxZQUFLLENBQUMsQ0FBQyxFQUFFLENBQUMsRUFBRSxDQUFDLEVBQUUsQ0FBQyxDQUFDO0VBRTdCOztFQUVBLEtBQUFDLFNBQVMsR0FBVSxJQUFJO0VBRXZCO0VBQ0EsS0FBQUMsY0FBYyxHQUFXLElBQUk7RUFFN0I7RUFDQSxLQUFBQyxTQUFTLEdBQWMsSUFBSTtFQUcxQixJQUFJUCxLQUFLLEdBQUcsQ0FBQyxFQUFFLE1BQU0sSUFBSVEsS0FBSyxDQUFDLHFCQUFxQixDQUFDO0VBQ3JELElBQUksQ0FBQ1AsSUFBSSxFQUFFLE1BQU0sSUFBSU8sS0FBSyxDQUFDLHNCQUFzQixDQUFDO0VBQ2xELElBQUksQ0FBQ04sUUFBUSxFQUFFLE1BQU0sSUFBSU0sS0FBSyxDQUFDLDBCQUEwQixDQUFDO0VBQzFELElBQUksQ0FBQ1IsS0FBSyxHQUFHQSxLQUFLO0VBQ2xCLElBQUksQ0FBQ0MsSUFBSSxHQUFHQSxJQUFJO0VBQ2hCLElBQUksQ0FBQ0MsUUFBUSxHQUFHQSxRQUFRO0FBQ3pCLENBQUM7QUFHRjtBQUFBTyxPQUFBLENBQUFWLFFBQUEsR0FBQUEsUUFBQTtBQUNBLElBQVlXLFNBQWdEO0FBQUFELE9BQUEsQ0FBQUMsU0FBQSxHQUFBQSxTQUFBO0FBQTVELFdBQVlBLFNBQVM7RUFBR0EsU0FBQSxDQUFBQSxTQUFBLDBCQUFNO0VBQUVBLFNBQUEsQ0FBQUEsU0FBQSw4QkFBUTtFQUFFQSxTQUFBLENBQUFBLFNBQUEsOEJBQVE7RUFBRUEsU0FBQSxDQUFBQSxTQUFBLDBCQUFNO0FBQUMsQ0FBQyxFQUFoREEsU0FBUyxLQUFBRCxPQUFBLENBQUFDLFNBQUEsR0FBVEEsU0FBUyJ9